export interface MultipleCarousel {
  rotationalDelay: number;
  media: Carousel[];
}

export interface MultipleCallToAction {
  rotationalDelay: number;
  media: CallToAction[];
}

export interface Carousel {
  mediaUrl?: string;
  staticPage?: string;
  targetlink?: string;
  documentNum?: number;
  documentName?: string;
}

export interface CallToAction {
  mediaUrl?: string;
  staticPage?: string;
  targetlink?: string;
  documentNum?: number;
  documentName?: string;
}

export interface CmsContent {
  contentNum?: number;
  contentName?: string;
  templateNum?: number;
  sequenceNum?: number;
  increaseImageHeight?: boolean;
  contentStructure?: string;
  contentStructureJson?: {
      cinId?: string;
      title?: string;
      mediaNum?: number;
      mediaUrl?: string;
      imagepath?: string;
      targetlink?: string;
      gcbMediaPath?: string;
      imageList?: any;
      Button?: any;
      description: any;
      rotationalDelay: any;
      staticPage?: number;
      documentNum?: number;
      documentName?: string;
  };
  rowUpdateStamp?: number
}

export interface StaticPageContent {
  contentName: string;
  contentNum: number;
  contentStructure: string;
  pageNum: number;
  rowUpdateStamp: number;
  sequenceNum: number;
  templateNum: number;
}

export interface ContentStructureDetails {
  mediaUrl: string;
  imagepath: string;
  recordList: RecordList[];
}

export interface RecordList {
  Button?: string;
  description?: string;
  documentName?: string;
  documentNum?: number;
  imagepath?: string;
  mediaUrl?: string;
  sequence?: number;
  staticPage?: any;
  targetlink?: string;
  title?: string;
}
export interface CMSMediaDocument {
  mediaLink?: string;
  mediaNum?: number;
}

export const CmsContentField = {
  ContentNum: 'contentNum',
  ContentName: 'contentName',
  TemplateNum: 'templateNum',
  sequenceNum: 'sequenceNum',
  RowUpdateStamp: 'rowUpdateStamp',
  PageNum: 'pageNum',
};